var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"vaimo-header-layers container min-h-[300px] border-b-[1px] border-secondary shadow-[0_0.5px_0px_0px_secondary]",class:_vm.pushBLockClasses,on:{"click":_vm.hide}},_vm._l((_vm.getSectionData),function(section){return _c(section.__typename,_vm._b({key:section.sys.id,tag:"component"},'component',{
        sectionData: section,
        mainLevelName: _vm.currentNav
      },false))}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }